/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { cardProviders } from '../../../../../screens/Card/constants';

const MAPPING = {
  [cardProviders.MONAVATE]: {
    x: 15,
    y: 145,
    fontSize: 16,
    fontWeight: 'bold',
  },
  [cardProviders.GALILEO]: {
    x: 15,
    y: 150,
    fontSize: 16,
    fontWeight: 'normal',
  },
};
export function IBAN({
  isShowSecretInfo = false,
  isLoadingPAN = false,
  cardProvider = null,
  cardNumberObscured = null,
  pan = null,
  onClick = () => {},
  panError = null,
}) {
  const { x = 15, y = 100, fontSize = 16, fontWeight = 'bold' } = MAPPING[cardProvider] || {};

  const galileoIPAN = cardNumberObscured?.match(/.{1,4}/g);
  if (cardProvider === cardProviders.GALILEO) {
    return (
      <g>
        <text
          fill="#2D2926"
          fontWeight={fontWeight}
          fontSize={fontSize}
          fontFamily="HM Alpha Mono"
          x={x}
          y={y}>
          {galileoIPAN && galileoIPAN?.length === 4
            ? `${galileoIPAN[0]} **** **** ${galileoIPAN[3]}`
            : '**** **** **** ****'}
        </text>
      </g>
    );
  }

  return (
    <g>
      {(!isShowSecretInfo || isLoadingPAN || panError || !pan) && (
        <text
          className="cursor-pointer"
          fill="white"
          fontWeight="bold"
          fontSize={fontSize}
          x={x}
          y={y}
          onClick={onClick}>
          {cardNumberObscured?.match(/.{1,4}/g)?.join(' ')}
        </text>
      )}
      {isShowSecretInfo && !isLoadingPAN && (
        <text fill="#142633" fontWeight={fontWeight} fontSize={fontSize} x={x} y={y}>
          {pan?.match(/.{1,4}/g)?.join(' ')}
        </text>
      )}
    </g>
  );
}
IBAN.propTypes = {
  isShowSecretInfo: PropTypes.bool,
  isLoadingPAN: PropTypes.bool,
  cardProvider: PropTypes.string,
  cardNumberObscured: PropTypes.string,
  pan: PropTypes.string,
  onClick: PropTypes.func,
  panError: PropTypes.object,
};
export default IBAN;
